import {
  ADD_ACTIVITY_FAIL,
  ADD_ACTIVITY_START,
  ADD_ACTIVITY_SUCCESS,
  GET_ACTIVITIES_FAIL,
  GET_ACTIVITIES_START,
  GET_ACTIVITIES_SUCCESS,
  PATCH_POLL_OPTION,
  SAVE_POLL_FILTER,
  ADVERTISMENT_REQUEST,
  ADVERTISMENT_ADD_SUCCESS,
  ADVERTISMENT_FAIL,
  SAVE_ADVERTISMENT_FILTER,
  SELECTED_CONTACTS_FOR_ADVERTISMENT,
  DELETE_ACTIVITY_START,
  DELETE_ACTIVITY_SUCCESS,
  DELETE_ACTIVITY_FAIL,
  EDIT_ADVERTISMENT_START,
  EDIT_ADVERTISMENT_SUCCESS,
  EDIT_ADVERTISMENT_FAIL,
} from "./constants";

import {
  getActivitiesStart,
  getActivitiesSuccess,
  getActivitiesFail,
  addActivityStart,
  addActivitySuccess,
  addActivityFail,
  patchPollOption,
  addAdvertismentStart,
  addAdvertismentSuccess,
  addAdvertismentFail,
  deleteActivityStart,
  deleteActivitySuccess,
  deleteActivityFail,
  editAdvertismentStart,
  editAdvertismentSuccess,
  editAdvertismentFail,
} from "./helper";

const initialState = {
  polls: [],
  advertisements: [],
  loading: true,
  error: "",
  filter: {},
  contacts: [],
};

const activitiesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // Get activities
    case GET_ACTIVITIES_START:
      return getActivitiesStart(state);
    case GET_ACTIVITIES_SUCCESS:
      return getActivitiesSuccess(state, payload);
    case GET_ACTIVITIES_FAIL:
      return getActivitiesFail(state, payload);

    // Add activity
    case ADD_ACTIVITY_START:
      return addActivityStart(state);
    case ADD_ACTIVITY_SUCCESS:
      return addActivitySuccess(state, payload);
    case ADD_ACTIVITY_FAIL:
      return addActivityFail(state, payload);

    // Add advertisment
    case ADVERTISMENT_REQUEST:
      return addAdvertismentStart(state, action);
    case ADVERTISMENT_ADD_SUCCESS:
      return addAdvertismentSuccess(state, action);
    case ADVERTISMENT_FAIL:
      return addAdvertismentFail(state, action);

    // Delete activity(adv)
    case DELETE_ACTIVITY_START:
      return deleteActivityStart(state, action);
    case DELETE_ACTIVITY_SUCCESS:
      return deleteActivitySuccess(state, action);
    case DELETE_ACTIVITY_FAIL:
      return deleteActivityFail(state, action);

    // Edit activities(avd)
    case EDIT_ADVERTISMENT_START:
      return editAdvertismentStart(state, action);
    case EDIT_ADVERTISMENT_SUCCESS:
      return editAdvertismentSuccess(state, action);
    case EDIT_ADVERTISMENT_FAIL:
      return editAdvertismentFail(state, action);

    case SAVE_ADVERTISMENT_FILTER:
      return { ...state, filter: action.filter };
    case SELECTED_CONTACTS_FOR_ADVERTISMENT:
      return { ...state, contacts: action.contacts };

    case SAVE_POLL_FILTER:
      return { ...state, filter: payload };
    case PATCH_POLL_OPTION:
      return patchPollOption(state, payload);
    default:
      return state;
  }
};

export default activitiesReducer;
